import { useNavigate } from "react-router-dom";
import Button from "../UI/Button";
import { ButtonTypes } from "../../utils/Constants";
import MainContainer from "../UI/MainContainer";
import usePageTitle from "../../utils/usePageTitle";

const NotFound404 = () => {
  usePageTitle("Page not found");
  const navigate = useNavigate();

  return (
    <MainContainer>
        <div className="flex flex-col items-center justify-center h-full">
          <h1 className="font-semibold text-6xl">404</h1>
          <h2 className="font-semibold text-2xl capitalize text-center mt-2">
            Page not found!
          </h2>
          <Button
            className="mt-8"
            type={ButtonTypes.PRIMARY}
            onClick={() =>  navigate("/", { replace: true })}
          >
            Home
          </Button>
        </div>
    </MainContainer>
  );
};

export default NotFound404;
